
import {
  IconChargingWire,
  IconComputerMouse,
  IconController,
  IconHdmi,
  IconHeart,
  IconKeyboard,
  IconPlug,
  IconPowerAdapterApple,
  RevLink,
  openModal,
} from '@backmarket/design-system'

import { MODAL_NAMES } from '@config/constants'

import ExcludedAccessoriesModal from '../Modals/ExcludedAccessoriesModal'

import translations from './Accessories.translations'
import Chip from './components/Chip'

const ICONS = {
  IconChargingWire,
  IconComputerMouse,
  IconController,
  IconHdmi,
  IconHeart,
  IconKeyboard,
  IconPlug,
  IconPowerAdapterApple,
}

export default {
  components: {
    RevLink,
    Chip,
    ExcludedAccessoriesModal,
  },
  props: {
    accessories: {
      type: Array,
      required: true,
    },
    showExcludedModal: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    translations: () => translations,

    shouldDisplayAccessories() {
      return !!this.accessories.length
    },

    items() {
      return this.accessories.map((accessory) => ({
        icon: ICONS[accessory.icon],
        label: accessory.text,
      }))
    },
  },
  methods: {
    handleModalOpen() {
      openModal(MODAL_NAMES.PRODUCT.EXCLUDED_ACCESSORIES)
    },
  },
}
